// @tennis-matches/clubmeisterschaft-core – Platzhalter bis Entry-Page existiert

import React from "react";
import { useOutletContext } from "react-router-dom";

export function ClubmeisterschaftEntryPlaceholder() {
  const { t } = useOutletContext() || {};
  const label = t ? t("club.entry.title") : "club.entry.title";
  return (
    <div className="card" data-page="clubmeisterschaft-entry-placeholder">
      <p className="muted">{label}</p>
    </div>
  );
}
